<section class="funfacts-area bg-image pt-100 pb-70">
  <div class="container">
    <div class="row">
      @for (Funfacts of singleFunfactsItem; track Funfacts) {
        <div class="col-lg-3 col-sm-3 col-6 col-md-3">
          <div class="single-funfacts-item">
            <div class="icon">
              <img [src]="Funfacts.icon" [alt]="Funfacts.subTitle + ' statistic icon'">
            </div>
            <h3>{{Funfacts.title}}</h3>
            <p>{{Funfacts.subTitle}}</p>
          </div>
        </div>
      }
    </div>
  </div>
</section>